import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';

@Component({
  selector: 'app-ai-route-craft',
  templateUrl: './ai-route-craft.component.html',
  styleUrls: ['./ai-route-craft.component.scss'],
})
export class AiRouteCraftComponent implements OnInit {

  routeCraftData: any;
  routeTitle: string = 'AI Route Craft';

  aiDaysArray: any[] = [];


  startDate:any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router
  ) { }

  ngOnInit() {
    let tripDetails = this._globalService.getUserTripDetails();
    this.startDate = tripDetails?.startDate ? new Date(tripDetails.startDate) : null;
    
    this.routeCraftData = this._globalService.getAiRouteCraft();
    this.routeTitle = this.routeCraftData?.title || 'AI Route Craft';
    this.routeCraftData = this.routeCraftData.days;

    console.log(this.routeCraftData);

    let daysArray: any[] = [];

    let keys = Object.keys(this.routeCraftData);

    for (let key of keys) {
      let item = this.routeCraftData[key];
      item.contentString = this.arrayToParagraphHtml(item.content);
      daysArray.push(item);
    }

    console.log(daysArray);

    this.aiDaysArray = daysArray;

  }

  getDayDate(dayIndex: number): string {
    // add dayIndex to startDate and return in formatDateToReadableString
    if (!this.startDate) {
      return '';
    } 
    let dayDate = new Date(this.startDate);
    dayDate.setDate(this.startDate.getDate() + dayIndex);
    return this.formatDateToReadableString(dayDate);
  }

  arrayToParagraphHtml(arr: string[]): string {
    if (!Array.isArray(arr) || !arr.length) {
      return '';
    }

    return arr
      .filter(item => item && item.trim()) // removes empty strings
      .map(item => `<p>${item}</p>`)
      .join('');
  }


  formatDateToReadableString(date: Date): string {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate();
    const year = date.getFullYear();

    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];

    // Get day suffix (st, nd, rd, th)
    const getDaySuffix = (day: number): string => {
      if (day >= 11 && day <= 13) return 'th';
      switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };

    const suffix = getDaySuffix(day);

    return `${day}${suffix} ${month}, ${year}`;
  }

  onSubmit(){
    this._router.navigate(['/hotel-selection']);
  }


}
